module.exports = __webpack_public_path__ + "static/media/Diamond.40ecb514.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Diamond.svg
// module id = 53
// module chunks = 0